module.exports = __webpack_public_path__ + "img/Drink.8b6ac92a.jpg";